import { ActionIcon, Box, Button, Menu } from "@mantine/core";
import { useOs } from "@mantine/hooks";
import {
    IconAlertTriangle,
    IconBrandWhatsapp,
    IconDots,
    IconFileLike,
    IconFlag,
    IconReport,
    IconSettings,
    IconShare,
    IconThumbDown,
    IconThumbUp,
    IconTrash,
} from "@tabler/icons";
import { useSession } from "next-auth/react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useRef } from "react";
import { useEffect, useState } from "react";
import ReportConcern from "./ReportConcern";

const Feedback = ({
    likescount = 38,
    unlikescount = 0,
    id,
    sharedata = "",
}) => {
    // console.log(id);
    const { data: session, status } = useSession();
    const [mounted, setMounted] = useState(false);

    const [liked, setLiked] = useState(null);
    const [likes, setLikes] = useState(likescount);
    const [unlikes, setUnlikes] = useState(unlikescount);

    const os = useOs();

    // use this for web
    let pclink = "https://web.whatsapp.com/send?text=";
    // use this link for mobiles
    let mobilelink = "whatsapp://send?text=";

    let whatsapplink = ["android", "ios"].includes(os) ? mobilelink : pclink;

    const menuRef = useRef(null);
    // id = "112244";

    const router = useRouter();

    // console.log({ path: router.basePath });

    useEffect(() => {
        // load all the previous doubts and solutions
        if (!!session && !!session.info) {
            setMounted(true);

            // localStorage.setItem(`liked.${id}`, null);
            let gi = localStorage.getItem(`liked.${id}`);
            if (gi === null || gi === "null") {
                // localStorage.setItem(`liked.${id}`, "null");
            } else {
                if (gi == "true") handleLike();
                if (gi == "false") handleUnlike();
            }
        }
    }, [session]);

    const handleLike = () => {
        if (liked === false) setUnlikes(unlikes - 1);

        if (liked !== true) {
            setLikes(likes + 1);
            setLiked(true);
            localStorage.setItem(`liked.${id}`, "true");
            console.log(`liked.${id}`);
        }

        if (liked == true) {
            setLikes(likes - 1);
            setLiked(null);
            localStorage.setItem(`liked.${id}`, "null");
            console.log(`liked.${id}`);
        }
    };
    const handleUnlike = () => {
        if (liked === true) setLikes(likes - 1);
        if (liked !== false) {
            setUnlikes(unlikes + 1);
            setLiked(false);
            localStorage.setItem(`liked.${id}`, "false");
            console.log(`liked.${id}`);
        }
        if (liked === false) {
            setUnlikes(unlikes - 1);
            setLiked(null);
            localStorage.setItem(`liked.${id}`, "null");
            console.log(`liked.${id}`);
        }
    };

    return (
        <Box
            sx={(theme) => ({
                display: mounted ? null : "none",
            })}
        >
            {/* need to be placed in top right */}
            <Button.Group orientation={"horizontal"}>
                <Button
                    radius={"lg"}
                    color={"green"}
                    variant={liked === true ? "filled" : "default"}
                    size="xs"
                    // disabled={liked === true}
                    onClick={handleLike}
                >
                    <IconThumbUp />
                    {/* {likes} */}
                </Button>
                <Button
                    radius={"lg"}
                    color={"red"}
                    variant={liked === false ? "filled" : "default"}
                    size="xs"
                    // disabled={liked === false}
                    onClick={handleUnlike}
                >
                    <IconThumbDown />
                    {/* {unlikes} */}
                </Button>
                <Link
                    target={"_blank"}
                    href={`${whatsapplink} Yaar!, mene problem solve kr dia h, ye rha :%0a ${sharedata} %0a _iss link se mujhe solution mila: ${
                        process.env.NEXT_PUBLIC_SITE_URL + router.asPath
                    }_  %0a *visit *${
                        process.env.NEXT_PUBLIC_SITE_URL
                    }* to learn more `}
                    legacyBehavior
                    passHref
                >
                    <Button
                        radius={"lg"}
                        color={"lime"}
                        variant={"light"}
                        size="xs"
                    >
                        <IconBrandWhatsapp />
                    </Button>
                </Link>
                {/* <Menu shadow="md" width={200}>
                    <Menu.Target>
                        <Button
                            radius={"lg"}
                            color={"blue"}
                            variant={"default"}
                            size="xs"
                        >
                            <IconDots />
                        </Button>
                    </Menu.Target>

                    <Menu.Dropdown>
                        <Menu.Label>Settings</Menu.Label>

                        <Menu.Item
                            color="red"
                            icon={<IconAlertTriangle size={14} />}
                        >
                            Report
                        </Menu.Item>
                    </Menu.Dropdown>
                </Menu> */}
            </Button.Group>
        </Box>
    );
};

export default Feedback;
